import { useEffect, useState } from 'react';
import './ContactPage.css';

export function ContactPage() {
  const [showPhone, setShowPhone] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Contact us — llmcontext';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="contact-page">
      <div className="contact-layout">
        <section className="contact-intro" aria-labelledby="contact-title">
          <p className="contact-kicker">Contact us</p>
          <h1 id="contact-title">Let&rsquo;s build amazing things together.</h1>
          <p>
            Have a suggestion or request, want to hear more, or want to use llmcontext at your
            company? Tell us what you are working on.
          </p>
        </section>

        <section className="contact-options" aria-label="Contact options">
          <article className="contact-option">
            <span>01</span>
            <h2>Email us</h2>
            <p>
              Questions, feature requests, partnerships, and private repository access are all
              welcome.
            </p>
            <a
              className="contact-action contact-action-primary"
              href="mailto:namaste@llmcontext.dev"
            >
              namaste@llmcontext.dev
            </a>
          </article>

          <article className="contact-option">
            <span>02</span>
            <h2>Call or text</h2>
            <p>
              Want to discuss bringing llmcontext into your company or setting up a self-hosted
              deployment? Talk directly with us.
            </p>
            {!showPhone ? (
              <button
                className="contact-action contact-action-secondary"
                type="button"
                onClick={() => setShowPhone(true)}
              >
                Show phone number
              </button>
            ) : (
              <div className="contact-phone" aria-live="polite">
                <strong>(310) 310-5325</strong>
                <div>
                  <a className="contact-action contact-action-primary" href="tel:+13103105325">
                    Call
                  </a>
                  <a className="contact-action contact-action-secondary" href="sms:+13103105325">
                    Text
                  </a>
                </div>
              </div>
            )}
          </article>
        </section>
      </div>
    </main>
  );
}
